import { localStorageGet } from '@Infra/LocalStorage';
import { LOCAL_STORAGE_KEYS } from '@Infra/LocalStorage/keys';

/**
 * Synchronous, not a thunk: `CurrentFacilityProvider` needs the persisted identifier at the same
 * tick it reads the freshly resolved assignments list, to run its three-test validation in a single
 * pass. Anything that is not a well-formed positive integer — no value yet, malformed content, a
 * leftover non-numeric string — resolves to `null`: a corrupted key never throws, it just reads as
 * "nothing persisted", which the caller always treats as safe to recompute.
 */
const readCurrentFacility = (): number | null => {
	const rawFacilityId = localStorageGet(LOCAL_STORAGE_KEYS.CURRENT_FACILITY_ID);

	if (rawFacilityId === null) {
		return null;
	}

	const parsedFacilityId = Number(rawFacilityId);

	if (!Number.isInteger(parsedFacilityId) || parsedFacilityId <= 0) {
		return null;
	}

	return parsedFacilityId;
};

export default readCurrentFacility;
